import React, {useEffect, useState} from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Widget from "../../../components/prefabricated/Widget";
import {useHistory} from 'react-router-dom'
import CIRTContinuousControlWidget
  from "../../../components/customBreachBits/controllers/CIRTControlButton/CIRTContinuousControlWidget";
import {useSelector} from "react-redux";
import {Badge} from "reactstrap";
import IntlMessages from "../../../util/IntlMessages";
import BBIconControls from "../../../assets/bbCustomIcons/BBIconControls";
import BBIconSettings from "../../../assets/bbCustomIcons/BBIconSettings";
import BBIconTutorialArrows from "../../../assets/bbCustomIcons/BBIconTutorialArrows";
// import {BBTourCIRTManual} from "../../../components/customBreachBits/BBTour";
import {
  bbConstructionCone, BBDisableChildren,
  bbDoesUserHaveAccessToModule, bbGetModulePropertyFromIdOrName,
  bbScopeIcon,
  isCurrentUserMemberOf
} from "../../../util/bbHelpers";
import {Chip} from "@material-ui/core";
import UserManualBanner from "../../../assets/images/User-Guide.svg";
import BBIconHexModule from "../../../assets/bbCustomIcons/BBIconHexModule";
import ShowIconShowingIfUserHasAccessToModule
  from "../../../components/customBreachBits/info/IconShowingIfCustomerHasAccessToModule";
import clsx from "clsx";
import {makeStyles} from "@material-ui/core/styles";
import TargetsDataTable from "../../../components/customBreachBits/targets/TargetsTable/TargetsDataTable";
import InsiderAttackOptionsDataTable
  from "../../../components/customBreachBits/requestedAttacks/InsiderAttackOptionsDataTable";
import RequestedAttacksDataTable from "../../../components/customBreachBits/requestedAttacks/RequestedAttacksDataTable";
import Button from "@material-ui/core/Button";
import BBIconPlay from "../../../assets/bbCustomIcons/BBIconPlay";
import BBIconQuickViewMagnifying from "../../../assets/bbCustomIcons/BBIconQuickViewMagnifying";
import BBIconRocketSharpAgainRedo from "../../../assets/bbCustomIcons/BBIconRocketSharpAgainRedo";
import URLSearchParams from "url-search-params";
import BBIconBellService from "../../../assets/bbCustomIcons/BBIconBellService";
import {HashLink as Link} from "react-router-hash-link";

const useStyles = makeStyles((theme) => ({
  root: {

  },
  sectionHeading: {
    width: '100%',
  },
  sectionHeadingTitle: {
    margin: 0,
    padding: 0,
    fontSize: "45px",
  },
  sectionHeadingSubtitle: {
    margin: 0,
    padding: 0,
    // fontSize: "45px",
  },
  sectionHeadingColumn: {
    alignSelf: "center",
  }
}));

const AoDComingSoon = (props) => {

  //variables grabbed form the URL parameters
  const {location, match,} = props;
  // const urlSection = location.search ? qs.parse(location.search, { ignoreQueryPrefix: true }).section : null;
  let urlSection = match.params.section
      ? match.params.section
      : null;

  let history = useHistory()
  const {customerInView} = useSelector(({customer}) => customer);
  const authUser = useSelector(({auth}) => auth.authUser);
  const isStaffAdmin = isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff");
  const isCustomer = isCurrentUserMemberOf(authUser, "customer");
  const isBRPortfolioCustomer = isCurrentUserMemberOf(authUser,"breachrisk_portfolio");
  const isBRBusinessCustomer = isCurrentUserMemberOf(authUser,"breachrisk");
  const isPartner = isCurrentUserMemberOf(authUser,"partner");

  // const [expanded, setExpanded] = useState(urlSection);
  const [expanded, setExpanded] = useState(false);
  const classes = useStyles();

  const handleChange = (panel) => (event, isExpanded) => {
    // setExpanded(() => expanded ? panel : false);
    //
    // //enables full back button and history behavior
    // if(expanded) {
    //   history.push(`/board/userguide/${panel}`)
    // } else {
    //   history.push(`/board/userguide`)
    // }
    setExpanded(isExpanded ? panel : false);
  };


  const {customers} = useSelector(({customer}) => customer);

  useEffect(() => {
  //enables full back button and history behavior
    setExpanded(urlSection);

    /*  jfd*******************************
     *   Appending clientID to URL
         ********************************** */
    const params = new URLSearchParams(window.location.search);
    const isPartner = isCurrentUserMemberOf(authUser, "partner");
    const isAdmin =  isCurrentUserMemberOf(authUser, "admin");
    const isStaff = isCurrentUserMemberOf(authUser, "staff");

    if ((isPartner
        || isAdmin
        || isStaff
    )) {
      //if they are a partner, staff, or admin, append the clientID search param

      if(customers
          && !params.has("clientID")
          && customerInView
      ) {
        //set the urlParameters
        params.set("clientID", customerInView)
        // console.log("getting params", params.get("clientID"));
        history.replace({
          search: params.toString(),
        })
      }
    }

  }, [customers, customerInView, window.location.search, match]);


  return (
    <div>
      {/*{ (isCustomer || isPartner || isStaffAdmin) &&*/}
      <>
      <div className="row my-3">

        <div className="col-12">
          {/*<div className={"row justify-content-center"}>*/}
            {/*<div id={"ModulesSection"} className={"col-12 align-self-center p-2 m-0"}>*/}

            {/*  <h1 className={"bb-font-fridge-bold m-1 p-0"} style={{fontSize: 55}}><BBIconHexModule className={"mr-3"} style={{fontSize: 90}}/><span className={"text-primary"}>{ title ? title : "Modules"}</span></h1>*/}
            {/*</div>*/}
          {/*</div>*/}

          <Accordion expanded={expanded === 'MonitorModule'} onChange={handleChange('MonitorModule')}>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
              <div className={clsx(classes.sectionHeading, "row")}>
                <div className={clsx(classes.sectionHeadingColumn,"col-5")}>
                  <div className={"row"}>
                    <div id={"MonitorSection"} className={clsx(classes.sectionHeadingColumn, "col-2")}>
                      <ShowIconShowingIfUserHasAccessToModule iconOnly iconSize={"75px"} module={"monitor"}/>
                    </div>
                    <div className={"col-1"}/>
                    <div className={clsx(classes.sectionHeadingColumn,"col-9 ")}>
                      <h2 className={clsx(classes.sectionHeadingTitle, "bb-font-fridge-bold")} >{bbGetModulePropertyFromIdOrName("monitor")}</h2>
                    </div>
                  </div>
                </div>

                <div className={clsx(classes.sectionHeadingColumn, "col-7")}>
                  <p className={clsx(classes.sectionHeadingSubtitle, "bb-font-fridge-light")}>
                    See what attackers see with continuous monitoring & risk discovery.
                  </p>
                </div>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <div>
                <h1>Monitor: the core BreachBits module.</h1>
                <p>At the core of BreachBits technology is a robust capability of observation, discovery, and reconnaissance.  Before an attacker can select and engage a target, the target must be discovered, understood, and sized up.  This is what the Monitor module does - 24x7.</p>
                <h2>Observe</h2>
                <p>Monitor doesn't simply perform network, port, and vulnerability scans, though those are certainly in the tool bag.  Monitor uses open and closed-sourced tools, tactics, and procedures to constantly maintain awareness. Anybody can detect a target once, but Monitor tracks targets as they ebb and flow in your cyberspace.</p>
                <h2>Orient</h2>
                <p>The other key activity of Monitor includes attack preparation.  Monitor prepares for attack by selecting vulnerable targets and pairing them with attack capabilities. This forms a <strong>Vector</strong>.  Monitor maintains a library of Vectors and makes predictions on their viability based on historical and predictive means.</p>
                <hr/>
                <h1>How to use Monitor</h1>
                <p>Nearly all BreachBits services include the Monitor module.  Let's check to see if you have this module active:</p>
                <div className={"row"}>
                  <div className={"col-3"}>
                    <ShowIconShowingIfUserHasAccessToModule module={"monitor"}/>
                  </div>
                  <div className={"col-9"}>
                    <p>If widget to the left says <Badge color="electric-blue-light">Enabled</Badge> then your company has access to the Monitor module.
                      If it says <Badge color="grey">Disabled</Badge> then your company has not subscribed to this module.  Check with BreachBits support at support@breachbits.com if you believe this is an error, or if you would like to add this module.</p>
                  </div>
                </div>
                <h2>Always Running</h2>
                <p>If the Monitor module is <Badge color="electric-blue-light">Enabled</Badge> then it is always running.  The only way to stop the module would be to contact support@breachbits.com to remove this module from your company's plan.</p>
                <h2>Viewing Results</h2>
                <p>The Monitor module runs as a subset of the <Link to={"CIRT/external"}>Perimeter module</Link>. The Attack Surface and Vectors tabs display the results. <Link to={"/board/CIRT/external"}>Visit the Perimeter module</Link>.</p>
                <hr/>
                <h1>Key Uses & Features</h1>
                <ul>
                  <li>Attack Surface Monitoring: Monitor provides persistent monitoring of your attack surface.</li>
                  <li>Basic Risk-Scoring: Using passive techniques gives a useful approximation of your risk of a breach.  Although the <Link to={"PerimeterModule"}>Perimeter</Link>, <Link to={"InsiderThreatModule"}>Insider Threat</Link>, and <Link to={"SocialModule"}>Social</Link> modules provide a more accurate risk score (because they use active attack methods), Monitor contributes about half of of the risk score input.</li>
                  <li>Asset Management: discover elements in your IT environment that were previously unknown, and simplify the challenge of tracking these assets.</li>
                </ul>
              </div>
            </AccordionDetails>
          </Accordion>

          <Accordion expanded={expanded === 'PerimeterModule'} onChange={handleChange('PerimeterModule')}>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
              <div className={clsx(classes.sectionHeading, "row")}>
                <div className={clsx(classes.sectionHeadingColumn,"col-5")}>
                  <div className={"row"}>
                    <div id={"PerimeterSection"} className={clsx(classes.sectionHeadingColumn, "col-2")}>
                      <ShowIconShowingIfUserHasAccessToModule iconOnly iconSize={"75px"} module={"perimeter"}/>
                    </div>
                    <div className={"col-1"}/>
                    <div className={clsx(classes.sectionHeadingColumn,"col-9 ")}>
                      <h2 className={clsx(classes.sectionHeadingTitle, "bb-font-fridge-bold")} >{bbGetModulePropertyFromIdOrName("perimeter")}</h2>
                    </div>
                  </div>
                </div>

                <div className={clsx(classes.sectionHeadingColumn, "col-7")}>
                  <p className={clsx(classes.sectionHeadingSubtitle, "bb-font-fridge-light")}>
                    Don't just monitor. Test your external systems with military-grade attacks.
                  </p>
                </div>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <div>
                <h1>Today, "potential problem" just doesn't cut it.</h1>
                <p>It is important to discover and monitor weaknesses, but don't stop there.  Actually attempt to exploit potential weaknesses with the Perimeter module. This "active" breach process is at the core of the Red Team ethos and the most powerful advantage of BreachBits over penetration testing and vulnerability scanning services.</p>
                <p>While the <Link to={"MonitorModule"}>Monitor module</Link> continuously measures your attack surface and potential attack Vectors, the Perimeter module then puts those discoveries to the test.  The Perimeter module actually attacks potential weaknesses with military-grade hacking tactics to find out if potential weaknesses are actual weaknesses.</p>
                <h2>Decide</h2>
                <p>The Perimeter module includes the Monitor module.  Once Monitor gains awareness of your attack surface and builds a library of potential Vectors, the Perimeter module then does what attackers do.  Targets are evaluated against potential goals of an attacker. Targets that, when exploited, would help an attacker achieve their objective, the target is selected for prosecution.</p>
                <h2>Act</h2>
                <p>Once targets are selected, Perimeter prosecutes attacks in the style and cadence of real attackers.  Some attackers are loud, some are quiet. Some are fast, some are slow.  Some attacks can take tens of thousands of attempts to work.  Once an attack is successful, Perimeter attempts to gather more information, select more targets, and further pursue attacker objectives.  When
                  attacks are finally deemed to be unsuccessful, the Vector is deemed "not viable" and the risk scoring of the company improves.</p>
                <hr/>
                <h1>How to use the Perimeter module</h1>
                <p>Let's check to see if you have this module active:</p>
                <div className={"row"}>
                  <div className={"col-4"}>
                    <ShowIconShowingIfUserHasAccessToModule module={"perimeter"}/>
                  </div>
                  <div className={"col-8"}>
                    <p>If widget to the left says <Badge color="electric-blue-light">Enabled</Badge> then your company has access to the Perimeter module.
                      If it says <Badge color="grey">Disabled</Badge> then your company has not subscribed to this module.  Check with BreachBits support at support@breachbits.com if you believe this is an error, or if you would like to add this module.</p>
                  </div>
                </div>
                <h2>Indirect Control with Continuous Perimeter Attacks and Scope</h2>
                <p>The Perimeter module is working around the clock, even without your intervention.  But there are two important ways that you can control it.  The first is with the Continuous Attacks setting.  The second is with host-level scope control.</p>
                <h3>Enabling and Disabling Continuous Perimeter Attacks</h3>
                <p>From the Overview tab of the <Link to={"/board/CIRT/external"}>Perimeter module</Link>, the Continuous
                  Attacks Control widget can be seen.  We've also placed a live copy right here:</p>
                <div className={"row"}>
                  <div className={"col-5"}>
                    <CIRTContinuousControlWidget customerId={customerInView}/>
                  </div>
                  <div className={"col-7"}>
                    <h4>Live Continuous Attacks Control Widget</h4>
                    <p>If the control widget to the left says <Badge color="bb-risk-lowest"><IntlMessages id={"badge.cirt.active"}/></Badge> then
                      Continuous Attacks is working right now.  If it says <Badge color="bb-risk-medium"><IntlMessages id={"badge.cirt.inactive"}/></Badge>
                      then it is not enabled and you should enable it as soon as you are ready. You can even use the button to the left now and turn it
                      right back off if you'd like to test it.  You will always know the status by looking at the widget, and you will get
                      a confirmation on your screen any time you change it.</p>
                  </div>
                </div>
                <h3>Setting Targets In-Scope and Out-of-Scope</h3>
                <p>From the Attack Surface tab of the <Link to={"/board/CIRT/external"}>Perimeter module</Link>, the All Systems Targets table provides a list of all system targets that have been discovered. Next to each item is an icon that indicates if the host is In-Scope or Out-of-Scope (OOS). The {bbScopeIcon(false)} icon indicates In-Scope.  The {bbScopeIcon(true)} icon indicates that the host is OOS.</p>
                <p>To change scope, you may select the icon to toggle between In-Scope and OOS.  Sometimes, hosts may be placed OOS by the BreachBits team if the host appears to be outside of your control.  <em>Hosts that are OOS are still monitored by the Monitor module.</em></p>
                {bbDoesUserHaveAccessToModule(authUser, 1) || isCurrentUserMemberOf(authUser, "admin")&&
                <>
                  <p>Since you have access to the Perimeter module, your All System Targets table has been inserted below.  You can try changing the toggling the scope icon.  You will see the icon change and you will get a feedback message if the change is successful.  <em>Remember that for some hosts, the scope may be automatically set by the BreachBits team for technical or legal reasons.</em></p>
                  <TargetsDataTable/>
                </>
                }
                <hr/>
                <h1>Key Uses & Features</h1>
                <ul>
                  <li>Actual attack attempts: Prove your system has mitigating controls beyond what vulnerability scanners and penetration testing results suggest.</li>
                  <li><Link to={"SafetyPromise"}>Safety Promise</Link>: All attacks use benign payloads.  We never attempt to degrade Availability or Integrity of your actual systems and data without getting your permission first.</li>
                  <li>High-Quality Risk Scoring: Go beyond the skin-deep cyber risk scoring.  Continuous, military-grade attack attempts allow us to provide you with the best insights of your risk.</li>
                </ul>
              </div>
            </AccordionDetails>
          </Accordion>

          <Accordion expanded={expanded === 'InsiderThreatModule'} onChange={handleChange('InsiderThreatModule')}>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
              <div className={clsx(classes.sectionHeading, "row")}>
                <div className={clsx(classes.sectionHeadingColumn,"col-5")}>
                  <div className={"row"}>
                    <div id={"InsiderThreatSection"} className={clsx(classes.sectionHeadingColumn, "col-2")}>
                      <ShowIconShowingIfUserHasAccessToModule iconOnly iconSize={"75px"} module={"insider"}/>
                    </div>
                    <div className={"col-1"}/>
                    <div className={clsx(classes.sectionHeadingColumn,"col-9 ")}>
                      <h2 className={clsx(classes.sectionHeadingTitle, "bb-font-fridge-bold")} >{bbGetModulePropertyFromIdOrName("insider")}</h2>
                    </div>
                  </div>
                </div>

                <div className={clsx(classes.sectionHeadingColumn, "col-7")}>
                  <p className={clsx(classes.sectionHeadingSubtitle, "bb-font-fridge-light")}>
                    Go inverted. Test your systems and people from the inside-out.
                  </p>
                </div>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <div>
                <h1>Assume Breach. Assume an Insider.</h1>
                <p>It is critically important to test your systems from the outside, but what about from the inside? The Insider Threat module provides the second viewpoint of the hacker's perspective, that of the insider.</p>
                <h2>Self-Directed</h2>
                <p>The Insider Threat module gives you enormous control.  You decide which hosts to test or which enclaves to assess. <strong>Attack on Demand</strong> allows you to select a single host for a specific attack.  This is the scalpel. <strong>Internal Assessments</strong> go broader by allowing for lateral movement on a limited-objective campaign.</p>
                <h2>Play-by-Play</h2>
                <p>The <Link to={"/board/CIRT/inspector"}>Attack Inspector</Link> provides attack timelines and event details that show you exactly what, when, and where activity occurred, as well as the results of attempted discover, execution, and exploitation events.</p>
                <hr/>
                <h1>How to use Insider Threat</h1>
                <p>Let's check to see if you have this module active:</p>
                <div className={"row"}>
                  <div className={"col-4"}>
                    <ShowIconShowingIfUserHasAccessToModule module={"insider"}/>
                  </div>
                  <div className={"col-8"}>
                    <p>If widget to the left says <Badge color="electric-blue-light">Enabled</Badge> then your company has access to the Insider Threat module.
                      If it says <Badge color="grey">Disabled</Badge> then your company has not subscribed to this module.  Check with BreachBits support at support@breachbits.com if you believe this is an error, or if you would like to add this module.</p>
                  </div>
                </div>
                <h2>Direct Control with Insider Attacks</h2>
                <p>While <Link to={"ExternalThreatsModule"}>Perimeter</Link> is focused on near-autonomous and continuous attacks, Insider Threat is currently focusing on a self-directed approach.  Attacks won't occur unless you order them via the <Link to={"/board/CIRT/insider"}>Insider Threat module</Link>.</p>
                {bbDoesUserHaveAccessToModule(authUser, 2) || isCurrentUserMemberOf(authUser, "admin")
                    ? <>
                      <p>Since you have access to the Insider Threat module, we've placed the menu of Insider Attacks below for your convenience.  To order an attack, simply select the action button next to the attack type you would like.  The attack will then be provisioned, and you will be able to start the attack on a host of your choice by downloading a custom script built-to-order. Not sure what to pick? Try an Internal Assessment, or contact support@breachbits.com for suggestions.</p>
                      <InsiderAttackOptionsDataTable customerId={customerInView}/>
                    </>
                    : <p></p>
                }
                <h3>Launching Attacks & Viewing Results</h3>
                <p>From the Insider Attacks tab of the <Link to={"/board/CIRT/insider"}>Insider Threat module</Link>, you can view a summary of all Insider Attacks you have ordered, and you can quickly access the Attack Timeline and Attack Inspector.</p>
                <ul>
                  <li>To launch an attack, select the pulsing <Button
                      variant="outlined"
                      color="default"
                      className={"bg-electric-blue text-white btn-floating pulse"}
                  >
                    <BBIconPlay/>
                  </Button> button to view and download attack files once the attack is <Chip color={"primary"} className={"btn-floating pulse"} label={"Ready"}/> , and follow the on-screen instructions.</li>
                  <li>To view attack results, select the Quick-view action <Button
                      variant="outlined"
                      color="default"
                      className={ "text-electric-blue"}
                  >
                    <BBIconQuickViewMagnifying />
                  </Button> next to an attack, and for more details select the Attack Inspector button from the Quick-view timeline.</li>
                  <li>To quickly order another attack of the same type, select the re-attack action. <Button
                      variant="outlined"
                      color="default"
                      disableElevation
                      className={`text-electric-blue `}
                  ><BBIconRocketSharpAgainRedo /></Button></li>
                </ul>
                {bbDoesUserHaveAccessToModule(authUser, "insider") || isCurrentUserMemberOf(authUser, "admin")
                    ? <>
                      <p>Since you have access to the Insider Threat module, we've placed your Insider Attacks Status Log below for your convenience.</p>
                      <RequestedAttacksDataTable customerId={customerInView}/>
                    </>
                    : <p/>
                }
                <hr/>
                <h1>Key Uses & Features</h1>
                <ul>
                  <li>Actual attack attempts: Prove your system has mitigating controls beyond what vulnerability scanners and penetration testing results suggest.</li>
                  <li><Link to={"SafetyPromise"}>Safety Promise</Link>: All attacks use benign payloads.  We never attempt to degrade Availability or Integrity of your actual systems and data without getting your permission first.</li>
                  <li>High-Quality Risk Scoring: Go beyond the skin-deep cyber risk scoring.  Continuous, military-grade attack attempts allow us to provide you with the best insights of your risk.</li>
                </ul>
              </div>
            </AccordionDetails>
          </Accordion>

          <Accordion expanded={expanded === 'SocialModule'} onChange={handleChange('SocialModule')}>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
              <div className={clsx(classes.sectionHeading, "row")}>
                <div className={clsx(classes.sectionHeadingColumn,"col-5")}>
                  <div className={"row"}>
                    <div id={"SocialSection"} className={clsx(classes.sectionHeadingColumn, "col-2")}>
                      <ShowIconShowingIfUserHasAccessToModule iconOnly iconSize={"75px"} module={"social"}/>
                    </div>
                    <div className={"col-1"}/>
                    <div className={clsx(classes.sectionHeadingColumn,"col-9 ")}>
                      <h2 className={clsx(classes.sectionHeadingTitle, "bb-font-fridge-bold")} >{bbGetModulePropertyFromIdOrName("social")}</h2>
                    </div>
                  </div>
                </div>

                <div className={clsx(classes.sectionHeadingColumn, "col-7")}>
                  <p className={clsx(classes.sectionHeadingSubtitle, "bb-font-fridge-light")}>
                    Discover, monitor, and attack the weakest link.
                  </p>
                </div>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <div>
                <h1>You've got mail.</h1>
                <p>Attacking the human element takes specialized tools, techniques, and procedures. Unlock the power of the CIRT Social module.</p>
                {/*<h2>{bbConstructionCone()} More to come</h2>*/}
                {/*<p>If you already have access to the Perimeter module, chances are you also have the Social module.  But we're making enhancements to this feature.  More information will be available soon.</p>*/}
                <p>Let's check to see if you have this module active:</p>
                <div className={"row"}>
                  <div className={"col-4"}>
                    <ShowIconShowingIfUserHasAccessToModule module={"social"}/>
                  </div>
                  <div className={"col-8"}>
                    <p>If widget to the left says <Badge color="electric-blue-light">Enabled</Badge> then your company has access to the Social module.
                      If it says <Badge color="grey">Disabled</Badge> then your company has not subscribed to this module, or your account has not yet been updated to reflect the enhanced, modular design of CIRT Social.  Check with BreachBits support at support@breachbits.com if you believe this is an error, or if you would like to add this module.</p>
                  </div>
                </div>
                <hr/>
                <h1>Key Uses & Features</h1>
                <ul>
                  <li>Multi-faceted discovery and tracking: Open source, closed source, dark web... we look where real attackers look. And when we find information on your people, we use it to craft high-quality attack packages.</li>
                  <li><Link to={"SafetyPromise"}>Safety Promise</Link>: All attacks use benign payloads.  We never attempt to degrade Availability or Integrity of your actual systems and data without getting your permission first.</li>
                  <li>Actual Payloads: This isn't your great-grandfather's phishing service.  We don't just see if someone opened our malicious emails, we attempt to further exploit the human and the systems, gaining initial access and other attack activities.  If your defenses stop the attack, you'll know exactly which control saved the day.  If your defenses fail, we safely demonstrate the extent of the would-be damage.</li>
                </ul>
              </div>
            </AccordionDetails>
          </Accordion>

          <Accordion expanded={expanded === 'ComplianceModule'} onChange={handleChange('ComplianceModule')}>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
              <div className={clsx(classes.sectionHeading, "row")}>
                <div className={clsx(classes.sectionHeadingColumn,"col-5")}>
                  <div className={"row"}>
                    <div className={clsx(classes.sectionHeadingColumn, "col-2")}>
                      {bbDoesUserHaveAccessToModule(authUser, "nist-171")
                          ? <ShowIconShowingIfUserHasAccessToModule iconOnly iconSize={"75px"} module={"nist-171"}/>
                          : <ShowIconShowingIfUserHasAccessToModule iconOnly iconSize={"75px"} module={"cmmc"}/>
                      }
                    </div>
                    <div className={"col-1"}/>
                    <div id={"ComplianceSection"} className={clsx(classes.sectionHeadingColumn,"col-9 ")}>
                      <h2 className={clsx(classes.sectionHeadingTitle, "bb-font-fridge-bold")} >{bbGetModulePropertyFromIdOrName("cmmc")}</h2>
                    </div>
                  </div>
                </div>

                <div className={clsx(classes.sectionHeadingColumn, "col-7")}>
                  <p className={clsx(classes.sectionHeadingSubtitle, "bb-font-fridge-light")}>
                    Reducing your lift with automatic validation and pre-assessment.
                  </p>
                </div>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <div>
                <h1>While we're under the hood...</h1>
                <p>Our monitoring and attack methods generate a deep understanding of your security controls.  We can then map them back to your applicable compliance standards to make your assessments faster, cheaper, and easier to complete.</p>
                <h2>{bbConstructionCone()} More to come</h2>
                <p>We are in early alpha with select clients on this feature, so chances are you don't have it yet. More information will be available soon.</p>
                <p>Let's check to see if you have this module active:</p>
                <div className={"row"}>
                  <div className={"col-4"}>
                    <ShowIconShowingIfUserHasAccessToModule module={"cmmc"}/>
                  </div>
                  <div className={"col-8"}>
                    <p>If widget to the left says <Badge color="electric-blue-light">Enabled</Badge> then your company has access to the Compliance module for the DoD Cybersecurity Maturity Model.
                      If it says <Badge color="grey">Disabled</Badge> then your company has not subscribed to this module, or your account has not yet been updated to reflect this new module.  Check with BreachBits support at support@breachbits.com if you believe this is an error, or if you would like to add this module.</p>
                  </div>
                </div>
                <div className={"row"}>
                  <div className={"col-4"}>
                    <BBDisableChildren comingSoon>
                      <ShowIconShowingIfUserHasAccessToModule module={"nist-171"}/>
                    </BBDisableChildren>

                  </div>
                  <div className={"col-8"}>
                    <p>(Coming Soon) If widget to the left says <Badge color="electric-blue-light">Enabled</Badge> then your company has access to the Compliance module for the NIST SP 800-171 Standard.
                      If it says <Badge color="grey">Disabled</Badge> then your company has not subscribed to this module, or your account has not yet been updated to reflect this new module.  Check with BreachBits support at support@breachbits.com if you believe this is an error, or if you would like to add this module.</p>
                  </div>
                </div>
                <hr/>
                <h1>Key Uses & Features</h1>
                <ul>
                  <li>Automatic validation: We collect near-forensic-level quality observations of your security controls while we conduct attacks.  We catalog these artifacts and map them to your compliance standard.</li>

                  <li>Data Exchange: Ingest the objective evidence collected and integrate it with the tools you're already using to track your compliance tasks.</li>
                </ul>
              </div>
            </AccordionDetails>
          </Accordion>
        </div>

      </div>
          </>
      {/*<hr/>*/}
      {/*<div className="row my-10">*/}
      {/*  <div className="col-12 text-center">*/}
      {/*    <h2>{bbConstructionCone()} More coming soon.</h2>*/}
      {/*  </div>*/}
      {/*</div>*/}
    </div>
  );
};

export default AoDComingSoon;

